import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import BranchForm from "./BranchForm";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { branchValidationForm } from "../../utils/validationSchemas";
import BranchSetting from "./BranchSetting";

const CreateBranch = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    watch,
    clearErrors,
    control,
  } = useForm<any>({
    resolver: yupResolver(branchValidationForm),
    defaultValues: {
      is_franchise: false,
      charge: 0,
      transit_charge: 0,
      charge_type: {
        id: "flat",
        name: "flat",
      },
    },
  });
  const { handleCreate, isLoading } = props;

  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleCreate}
        setError={setError}
        buttonLabel={"Create"}
        isLoading={isLoading}
      >
        <BranchForm
          clearErrors={clearErrors}
          errors={errors}
          register={register}
          setValue={setValue}
          getValues={getValues}
          watch={watch}
          control={control}
          isCreate={true}
        />
      </FormLayout>
    </>
  );
};

export default CreateBranch;
